export default __webpack_public_path__ + "static/media/IconDesc_CoolingSystem.256.d0bbcff1.png";